// extracted by mini-css-extract-plugin
export default {"cls1":"PaperContainer-cls1_QED","cls2":"PaperContainer-cls2_Sh5 PaperContainer-cls1_QED"};